import { IDataReaderClient } from "@multiweb/clients/dataReader";
import { IUserClient } from "@multiweb/clients/user";
import { IUserSettingsClient } from "@multiweb/clients/userSettings";
import { ISectionLogger } from "@multiweb/logging";
import { isVersionOlderOrEqual } from "Global/Base/Utils/versionUtils";
import { ICommunicationManager } from "OW.Remoting/Remoting/ICommunicationManager";
import { LegacyUpTo2002UserSettingsClient } from "./LegacyUpTo2002UserSettingsClient";
import { UserSettingsClient } from "./UserSettingsClient";

export function defaultFactory(communicationManager: ICommunicationManager, userClient: IUserClient, dataReaderClient: IDataReaderClient, logger: ISectionLogger, webServiceVersion?: string): IUserSettingsClient {
    return isVersionOlderOrEqual(webServiceVersion, "20.02") ? new LegacyUpTo2002UserSettingsClient(communicationManager, userClient, dataReaderClient, logger) : new UserSettingsClient(communicationManager, userClient, dataReaderClient, logger);
}
